module.exports = __webpack_public_path__ + "3beec9a4108e450d1beaae410e8a9ba7.jpg";